/** An independent copy, including fresh attachment references. The caller copies local bytes. */
export function forkDocument(source, mapId, title, now) {
    const nodeIds = new Map();
    const attachmentIds = new Map();
    let index = 0;
    for (const node of Object.values(source.nodes)) {
        nodeIds.set(node.id, `${mapId}_n${String(index++)}`);
        const content = node.metadata?.content;
        if (content !== null &&
            typeof content === 'object' &&
            !Array.isArray(content) &&
            'attachmentId' in content &&
            typeof content.attachmentId === 'string') {
            const id = content.attachmentId;
            if (!attachmentIds.has(id))
                attachmentIds.set(id, `${mapId}_a${String(attachmentIds.size)}`);
        }
        for (const id of node.attachments ?? []) {
            if (!attachmentIds.has(id))
                attachmentIds.set(id, `${mapId}_a${String(attachmentIds.size)}`);
        }
    }
    const nodeId = (id) => {
        const next = nodeIds.get(id);
        if (next === undefined)
            throw new Error('Invalid node reference in map copy');
        return next;
    };
    const nodes = {};
    for (const node of Object.values(source.nodes)) {
        const id = nodeId(node.id);
        const metadata = node.metadata ?? {};
        nodes[id] = {
            ...node,
            id,
            mapId,
            parentId: node.parentId === null ? null : nodeId(node.parentId),
            metadata: {
                ...metadata,
                ...(metadata.content !== null &&
                    typeof metadata.content === 'object' &&
                    !Array.isArray(metadata.content) &&
                    'attachmentId' in metadata.content &&
                    typeof metadata.content.attachmentId === 'string'
                    ? {
                        content: {
                            ...metadata.content,
                            attachmentId: attachmentIds.get(metadata.content.attachmentId) ??
                                metadata.content.attachmentId,
                        },
                    }
                    : {}),
                ...(metadata.mapLink !== null &&
                    typeof metadata.mapLink === 'object' &&
                    !Array.isArray(metadata.mapLink) &&
                    'mapId' in metadata.mapLink &&
                    metadata.mapLink.mapId === source.map.id
                    ? { mapLink: { ...metadata.mapLink, mapId } }
                    : {}),
            },
            ...(node.attachments === undefined
                ? {}
                : { attachments: node.attachments.map((id) => attachmentIds.get(id) ?? id) }),
        };
    }
    const edges = {};
    for (const edge of Object.values(source.edges)) {
        const id = `${mapId}_e${String(index++)}`;
        edges[id] = {
            ...edge,
            id,
            mapId,
            sourceNodeId: nodeId(edge.sourceNodeId),
            targetNodeId: nodeId(edge.targetNodeId),
        };
    }
    return {
        nodeIds,
        attachmentIds,
        document: {
            map: {
                ...source.map,
                id: mapId,
                rootNodeId: nodeId(source.map.rootNodeId),
                title,
                localRevision: 0,
                serverRevision: 0,
                createdAt: now,
                updatedAt: now,
                deletedAt: null,
            },
            nodes,
            edges,
        },
    };
}
//# sourceMappingURL=fork.js.map